import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/cells/')({
  component: () => (
    <EmptyState icon="grid" title="Выбери ячейку" description="Слева — собранные ячейки" />
  ),
})
